/* Available sizes */
export const SIZE_RESPONSIVE = 'responsive' as const;
export const SIZE_SMALL = 'small' as const;
export const SIZE_MEDIUM = 'medium' as const;
export const SIZE_LARGE = 'large' as const;
